// import Select from 'components/Select';
import { Button, Input, Select } from 'antd';
import Table from 'components/Table';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import { useEffect, useRef, useState } from 'react';
import { convertAudienceType, getAttributeValues, getAudience } from 'services/ManageCustomerBase';
import {
  delete_audience,
  exportAudience,
  getAttributes,
  getColumnToExportAudience,
} from 'services/audience_management';
// import EditCustomerBase from './EditCustomerBase/EditCustomerBase';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import { Link, useNavigate } from 'react-router-dom';
import EditCondition from './EditCondition';
import { CustomerBase } from 'config';
import checkPermissionFunction from 'Permission';
import Loading from 'components/Animation/Loading';
import { formatNumber } from 'helpers';

// Sau khi Empty, backend dọn dữ liệu ở nền nên phải tự hỏi lại danh sách để biết lúc nào xong
const CLEARING_POLL_INTERVAL = 15000;
const CLEARING_POLL_MAX_ATTEMPTS = 40; // ~10 phút, tránh hỏi lại vô hạn nếu job nền hỏng

const CustomerSet = () => {
  const path = 'CustomerSet';
  const [status, set_status] = useState(0);
  const [type, set_type] = useState(0);
  const [search, set_search] = useState('');
  const [Pending, Set_Pending] = useState(true);
  const [data, set_data] = useState([]);
  const [row, set_row] = useState([]);
  const [conditionValue, set_conditionValue] = useState({});
  const [subAttribute, set_subAttribute] = useState({});
  const [showCondition, set_showCondition] = useState({});
  const [ColumnToExport, set_ColumnToExport] = useState([]);
  const [exportedTypeIds, set_exportedTypeIds] = useState([]);
  const [selectedDataIds, set_selectedDataIds] = useState([]);
  const [select_row, set_select_row] = useState([]);
  const [showmodal, set_showmodal] = useState(false);
  const [attributeValues, set_attributeValues] = useState([]);
  const [listattribute, set_listattribute] = useState({});
  const [row_detail, set_row_detail] = useState({});

  const [CustomerBase_Type, set_CustomerBase_Type] = useState([]);
  const [CustomerBase_Status, set_CustomerBase_Status] = useState([]);
  const [showEdit, set_showEdit] = useState(false);
  // Id các tập vừa bấm Empty, backend đang dọn ngầm nên khóa sửa / chuyển đổi
  const [clearingIds, set_clearingIds] = useState([]);

  const [isLoading, set_loading] = useState(false);

  const navigate = useNavigate();
  const fetchDataRef = useRef(null);

  // useEffect(() => {
  //     console.log(data);
  // }, [data]);

  function OnSearch(value) {
    set_search(value.trim());
  }

  function changeStatus(value) {
    set_status(value);
  }

  function changeType(value) {
    set_type(value);
  }

  useEffect(() => {
    fetchData();
    async function fetchColumnToExport() {
      const res = await getColumnToExportAudience();
      set_ColumnToExport(res.data.data);
    }
    fetchColumnToExport();
    set_CustomerBase_Type(CustomerBase.type.filter((item) => item.id != 0));
    set_CustomerBase_Status(CustomerBase.status.filter((item) => item.id != 0));
  }, []);

  async function fetchData(silent = false) {
    if (!silent) Set_Pending(true);
    const res = await getAudience(search, status == 0 ? null : status, type == 0 ? null : type);
    if (!silent) Set_Pending(false);
    const list = res.data.data;
    set_data(list);
    // Tập nào đã về 0 khách hàng (hoặc không còn trong danh sách) coi như đã dọn xong -> mở khóa
    set_clearingIds((ids) =>
      ids.filter((id) => {
        const item = list?.find((row) => row.id == id);
        return item != null && Number(item.customerTotal) > 0;
      })
    );
  }

  useEffect(() => {
    fetchDataRef.current = fetchData;
  });

  useEffect(() => {
    if (clearingIds.length == 0) return undefined;
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (attempts > CLEARING_POLL_MAX_ATTEMPTS) {
        clearInterval(timer);
        set_clearingIds([]);
        return;
      }
      fetchDataRef.current(true);
    }, CLEARING_POLL_INTERVAL);
    return () => clearInterval(timer);
  }, [clearingIds.length]);

  const handleEmptied = (audienceId) => {
    set_clearingIds((ids) => (ids.includes(audienceId) ? ids : [...ids, audienceId]));
    set_showEdit(false);
    fetchData();
  };

  const handleDelete = async (row) => {
    let check = false;
    await Swal.fire({
      title: t('Notification'),
      text: `Bạn có chắc chắn muốn xóa tập khách hàng "${row.name}" này không?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('Cancel'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
    }).then(async function (result) {
      if (result.value) {
        check = true;
      } else {
        check = false;
      }
    });
    try {
      if (check == true) {
        Set_Pending(true);
        await delete_audience(row.id);
        toast.success('Xóa thành công');
      }
    } catch (err) {
      toast.error(err.response?.data?.showMessage ?? 'Xóa tập khách hàng thất bại');
    }
    await fetchData();
    Set_Pending(false);
  };

  const handleEdit = (row) => {
    set_showEdit(true);
    set_row_detail(row);
    if (row?.type == 2) {
      set_conditionValue(JSON.parse(row.conditionValue ?? {}));
      set_showCondition(JSON.parse(row.showCondition ?? {}));
      set_subAttribute(JSON.parse(row.subAttribute ?? {}));
    }
    // set_condition(conditionObject);
  };

  async function Download(row) {
    set_select_row([row.id]);
    set_exportedTypeIds([]);
    set_selectedDataIds(
      ColumnToExport.filter((item) => item.isDefaultSelected).map((item) => item.id)
    );
    set_showmodal(true);
  }

  const handleConvert = async (row) => {
    await Swal.fire({
      title: 'Chuyển đổi tập khách hàng',
      text: 'Bạn có chắc chắn muốn chuyển đổi tập khách hàng này? (Dữ liệu sẽ được sync sang MySQL/ClickHouse)',
      icon: 'question',
      input: 'select',
      inputOptions: {
        1: 'Subscribe (Đăng ký)',
        2: 'Unsubscribe (Hủy đăng ký)',
      },
      inputPlaceholder: 'Chọn cấu hình Firebase Topic (Bắt buộc)',
      showCancelButton: true,
      confirmButtonText: 'Chuyển đổi',
      cancelButtonText: 'Hủy',
      customClass: {
        confirmButton: 'btn btn-primary font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Bạn phải chọn cấu hình Firebase Topic để tiếp tục';
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const firebaseTopic = result.value;
        try {
          set_loading(true);
          const res = await convertAudienceType(row.id, firebaseTopic);
          if (res.data.code === 200) {
            toast.success(res.data.data.message || 'Đã gửi yêu cầu chuyển đổi.');
            fetchData();
          } else {
            toast.error(res.data.message || 'Có lỗi xảy ra.');
          }
        } catch (e) {
          toast.error(e.response?.data?.message || 'Có lỗi xảy ra.');
        } finally {
          set_loading(false);
        }
      }
    });
  };

  const columns = [
    {
      name: 'TÊN TỆP KHÁCH HÀNG',
      selector: (row) => row.name,
    },
    {
      name: 'MÔ TẢ',
      selector: (row) => (
        <div className="d-flex flex-column">
          <span>{row.description}</span>
          <div className="text-muted mt-1" style={{ fontSize: '11px', lineHeight: '1.2' }}>
            <div>ID: {row.id}</div>
            <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>Code: {row.code}</div>
          </div>
        </div>
      ),
      // sort: true,
      type: 'date',
    },
    {
      name: 'LOẠI TẬP KHÁCH HÀNG',
      selector: (row) => {
        if (row.type == 1) return 'Tập Tĩnh';
        if (row.type == 2) return 'Tập Động';
        if (row.type == 3) return 'Thống kê';
        if (row.type == 4) return <span className="text-warning font-weight-bold">Đang chuyển đổi...</span>;
        return CustomerBase_Type.find((item) => item.id == row.type)?.name;
      },
      // sort: true,
      type: 'number',
    },
    {
      name: 'TỔNG KHÁCH HÀNG',
      selector: (row) =>
        clearingIds.includes(row.id) ? (
          <div className="d-flex flex-column">
            <span>{formatNumber(row?.customerTotal)}</span>
            <span className="text-warning" style={{ fontSize: '11px' }}>
              <span
                className="spinner-border spinner-border-sm text-warning mr-1"
                role="status"
              ></span>
              Đang dọn...
            </span>
          </div>
        ) : (
          formatNumber(row?.customerTotal)
        ),
      // sort: true,
      type: 'number',
    },
    {
      name: 'TỔNG SỐ SUBCRIBE THÀNH CÔNG',
      selector: (row) => formatNumber(row?.totalSubcribeSuccess),
    },
    {
      name: 'NGÀY TẠO',
      selector: (row) => row?.createdAt ?? '',
    },
    {
      name: 'NGƯỜI TẠO',
      selector: (row) => row?.createdBy || 'System',
    },
    {
      name: 'NGƯỜI SỬA',
      selector: (row) => row?.updatedBy || 'System',
    },
    {
      cell: (row) => {
        // Đang dọn -> backend khóa tập, gọi edit-audience / convert-audience-type sẽ nhận 400
        const isClearing = clearingIds.includes(row.id);
        if (row.type == 4) {
          return (
            <span className="spinner-border spinner-border-sm text-warning" role="status"></span>
          )
        }
        if (row.type == 3) {
          return (
            <div className="d-flex align-items-center gap-2">
              <KTTooltip
                text={isClearing ? 'Đang dọn tập khách hàng, vui lòng đợi' : 'Chuyển đổi'}
              >
                <a
                  className={`btn btn-icon btn-sm btn-light-primary btn-hover-primary ${
                    isClearing ? 'disabled' : ''
                  }`}
                  onClick={() => {
                    if (isClearing) return;
                    checkPermissionFunction(path, 'edit', () => handleConvert(row));
                  }}
                >
                  <i className="fa fa-exchange-alt p-0 icon-1x"></i>
                </a>
              </KTTooltip>
              <KTTooltip text="Xóa">
                <a
                  className="btn btn-icon btn-sm btn-light-danger btn-hover-bg-danger"
                  onClick={() => {
                    checkPermissionFunction(path, 'delete', () => handleDelete(row));
                  }}
                >
                  <i className="fa fa-trash p-0 icon-1x"></i>
                </a>
              </KTTooltip>
            </div>
          );
        }
        if (row.type == 2) {
          return (
            <div className="d-flex align-items-center gap-2">
              <KTTooltip text="Xóa">
                <a
                  className="btn btn-icon btn-sm btn-light-danger btn-hover-bg-danger"
                  onClick={() => {
                    checkPermissionFunction(path, 'delete', () => handleDelete(row));
                  }}
                >
                  <i className="fa fa-trash p-0 icon-1x"></i>
                </a>
              </KTTooltip>
            </div>
          );
        }
        return (
          <div className="d-flex align-items-center gap-2">
            <KTTooltip text={isClearing ? 'Đang dọn tập khách hàng, vui lòng đợi' : 'Chỉnh sửa'}>
              <a
                className={`btn btn-icon btn-sm btn-light-primary btn-hover-primary ${
                  isClearing ? 'disabled' : ''
                }`}
                onClick={() => {
                  if (isClearing) return;
                  checkPermissionFunction(path, 'edit', () => handleEdit(row));
                }}
              >
                <i className="fa fa-pen p-0 icon-1x"></i>
              </a>
            </KTTooltip>

            {/* <KTTooltip text="Tải về">
              <a
                className="btn btn-icon btn-sm btn-light-primary btn-hover-primary"
                onClick={() => {
                  checkPermissionFunction(path, 'export', () => Download(row));
                }}
              >
                <i className="fa fa-file-download p-0 icon-1x"></i>
              </a>
            </KTTooltip> */}
            <KTTooltip text="Xóa">
              <a
                className="btn btn-icon btn-sm btn-light-danger btn-hover-bg-danger"
                onClick={() => {
                  checkPermissionFunction(path, 'delete', () => handleDelete(row));
                }}
              >
                <i className="fa fa-trash p-0 icon-1x"></i>
              </a>
            </KTTooltip>
          </div>
        );
      },
      button: true,
    },
  ];

  const exportData = async () => {
    set_loading(true);
    if (select_row.length == 0) return toast.error('Vui lòng chọn tập khách hàng');
    if (exportedTypeIds.length == 0) return toast.error('Vui lòng chọn loại dữ liệu xuất');
    if (selectedDataIds.length == 0) return toast.error('Vui lòng chọn cột dữ liệu xuất');
    const values = {
      audienceIds: select_row,
      exportedTypeIds: exportedTypeIds,
      selectedDataIds: selectedDataIds,
    };
    set_showmodal(false);
    await exportAudience(values);
    set_loading(false);
  };

  useEffect(() => {
    async function refeshData() {
      let obj = Object.assign({}, listattribute);
      for (let i = 0; i < attributeValues.length; i++) {
        if (!(attributeValues[i] in listattribute)) {
          const id = attributeValues[i];
          const value = await getAttributeValues(id);
          obj[id] = value.data.data;
        }
        // console.log(attributeValues[i]);
      }
      set_listattribute(obj);
    }
    refeshData();
  }, [attributeValues]);

  async function FcExport() {
    if (row.length == 0) return toast.error('Vui lòng chọn tập khách hàng');
    set_select_row(row.map((item) => item.id));
    set_exportedTypeIds([]);
    set_selectedDataIds(
      ColumnToExport.filter((item) => item.isDefaultSelected).map((item) => item.id)
    );
    set_showmodal(true);
  }

  return (
    <>
      {showEdit == false ? (
        <div>
          {<Loading isLoading={isLoading} />}
          <div className="container-fluid">
            <div className="bg-white card pt-5">
              <div className="card-header border-0 pt-6 pb-0">
                <div className="w-100 d-flex justify-content-between">
                  <div className="card-title my-0">
                    <h3 className="card-label">
                      <b>QUẢN LÝ TẬP KHÁCH HÀNG</b>{' '}
                    </h3>
                  </div>
                  <div className="card-toolbar gap-2 d-flex">
                    {/* <div
                      className="btn-primary btn font-weight-bold d-flex align-items-center"
                      onClick={(e) => {
                        checkPermissionFunction(path, 'export', () => FcExport());
                      }}
                    >
                      <i className="fa fa-file-download" />
                      Export
                    </div> */}
                    <div className="w-full h-full d-flex align-items-center">
                      {/* <Link to="/LichViet/AddCustomerBase" style={{ color: 'white' }}> */}
                      <Button
                        className="w-full h-full"
                        type="primary"
                        onClick={() => {
                          checkPermissionFunction(path, 'add', () =>
                            navigate('/LichViet/AddCustomerBase')
                          );
                        }}
                      >
                        <i className="fa fa-plus" style={{ color: 'white' }} />
                        Tạo tập khách hàng
                      </Button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap gap-3">
                  <div>
                    <div>Tìm kiếm</div>
                    <Input
                      placeholder="Tìm kiếm"
                      onChange={(value) => {
                        OnSearch(value.target.value);
                      }}
                    />
                    {/* <div className="relative">
                      <input
                        type="search"
                        className="border border-gray-300 text-gray-900 text-sm rounded-lg pl-10 pr-3 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        placeholder="Tìm kiếm"
                        onChange={(e) => {
                          OnSearch(e.target.value);
                        }}
                      />
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-gray-500"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                          />
                        </svg>
                      </div>
                    </div> */}
                  </div>
                  <div>
                    <div>Trạng thái</div>
                    <Select
                      defaultValue={CustomerBase.status.find((item) => item.id == status)?.name}
                      style={{ width: '200px' }}
                      onChange={(value) => {
                        changeStatus(value);
                      }}
                      options={CustomerBase.status.map((item) => {
                        return { label: item.name, value: item.id };
                      })}
                    />
                  </div>

                  <div>
                    <div>Loại tập khách hàng</div>
                    <Select
                      defaultValue={CustomerBase.type.find((item) => item.id == type)?.name}
                      style={{ width: '200px' }}
                      onChange={(value) => {
                        changeType(value);
                      }}
                      options={CustomerBase.type.map((item) => {
                        return { label: item.name, value: item.id };
                      })}
                    />
                  </div>

                  <div className="flex items-end">
                    <div
                      className="btn-primary btn font-weight-bold d-flex align-items-center"
                      style={{ height: '55%' }}
                      onClick={(e) => fetchData()}
                    >
                      <i className="fa fa-search icon-1x icon-sm" />
                      Tìm kiếm
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-3 d-flex flex-column max-h-100">
                <Table
                  columns={columns}
                  data={data}
                  maxHeight={65}
                  values={(value) => {
                    set_row(value);
                  }}
                  progressPending={Pending}
                />
              </div>
            </div>
          </div>
          {showmodal && (
            <div
              className="modal fade show"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              style={{ display: 'block', paddingRight: '6px' }}
              role="dialog"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="px-5 py-5 modal-header">
                    <div className="modal-title w-full grid justify-items-center">
                      Cấu hình export dữ liệu
                    </div>
                    <div
                      className="btn btn-xs btn-icon btn-light btn-hover-secondary cursor-pointer"
                      onClick={() => set_showmodal(false)}
                    >
                      <i className="fa fa-times"></i>
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="container pt-3 pb-3">
                      <div>
                        <b>Loại dữ liệu xuất</b>
                      </div>
                      <div className="row pt-3">
                        <div className="col flex justify-content-start gap-1">
                          <input
                            type="checkbox"
                            checked={exportedTypeIds.includes(1)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                set_exportedTypeIds([...exportedTypeIds, 1]);
                              } else {
                                set_exportedTypeIds(exportedTypeIds.filter((item) => item != 1));
                              }
                            }}
                          />
                          <span>Export theo customer id</span>
                        </div>
                        <div className="col flex justify-content-start gap-1">
                          <input
                            type="checkbox"
                            checked={exportedTypeIds.includes(2)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                set_exportedTypeIds([...exportedTypeIds, 2]);
                              } else {
                                set_exportedTypeIds(exportedTypeIds.filter((item) => item != 2));
                              }
                            }}
                          />
                          <span>Export theo user id</span>
                        </div>
                      </div>
                    </div>
                    <div className="container pt-3 pb-3">
                      <div>
                        <b>Các cột dữ liệu</b>
                      </div>
                      {ColumnToExport.reduce((resultArray, item, index) => {
                        const chunkIndex = Math.floor(index / 2);

                        if (!resultArray[chunkIndex]) {
                          resultArray[chunkIndex] = []; // start a new chunk
                        }

                        resultArray[chunkIndex].push(item);

                        return resultArray;
                      }, []).map((items, index) => {
                        return (
                          <div key={index} className="row pt-3">
                            {items.map((item, subIndex) => (
                              <div key={subIndex} className="col flex justify-content-start gap-1">
                                <input
                                  type="checkbox"
                                  defaultChecked={item?.isDefaultSelected}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      set_selectedDataIds([...selectedDataIds, item.id]);
                                    } else {
                                      set_selectedDataIds(
                                        selectedDataIds.filter((dataId) => dataId != item.id)
                                      );
                                    }
                                  }}
                                />
                                <span>{item.name}</span>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                      {/* <div className="flex justify-content-between pt-3">
                  <div className="flex justify-content-center gap-1">
                    <input type="checkbox" />
                    <span>Export theo customer id</span>
                  </div>
                  <div className="flex justify-content-center gap-1">
                    <input type="checkbox" />
                    <span>Export theo user id</span>
                  </div>
                </div> */}
                    </div>
                    <div className="grid justify-items-center">
                      <div
                        className={`${selectedDataIds.length == 0 || exportedTypeIds.length == 0
                          ? 'disabled'
                          : ''
                          } btn btn-primary`}
                        style={{ width: '25%' }}
                        onClick={() => {
                          exportData();
                        }}
                      // data-dismiss="modal"
                      >
                        EXPORT
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <EditCondition
          name={row_detail?.name}
          id={row_detail?.id}
          descriptionDefault={row_detail?.description}
          sub_attribute={subAttribute}
          condition_value={conditionValue}
          show_condition={showCondition}
          statusDefault={row_detail?.status}
          typeDefault={row_detail?.type}
          firebase={row_detail?.fireBaseTopic}
          customize={row_detail?.customizeType}
          stat={row_detail?.status}
          link={row_detail?.link}
          customerTotal={row_detail?.customerTotal}
          minStayTimeDefault={row_detail?.minStayTime}
          maxStayTimeDefault={row_detail?.maxStayTime}
          onSave={() => {
            set_showEdit(false);
            fetchData();
          }}
          onEmptied={handleEmptied}
        />
      )}
    </>
  );
};
export default CustomerSet;
